import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=270982ef&scoped=true"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPassword.vue?vue&type=style&index=0&id=270982ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270982ef",
  null
  
)

export default component.exports